import { useRef } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'
import AccessGroup from 'modules/core/store/models/AccessGroup'

interface Props {
  fqlQuery: Field
}

function FqlGroupSelection({ fqlQuery }: Props) {
  const groupOptions = useRef([
    {
      value: AccessGroup.QueryId.fqlTeam,
      label: i18n.t('settings.permissions.visibility.choices.their_own_team'),
    },
    {
      value: AccessGroup.QueryId.fqlLocation,
      label: i18n.t('settings.permissions.visibility.choices.their_own_workplace'),
    },
    {
      value: AccessGroup.QueryId.fqlLegalEntity,
      label: i18n.t('settings.permissions.visibility.choices.their_own_legal_entity'),
    },
  ]).current

  return (
    <Box gap="s16">
      <Select none={i18n.t('common.none')} field={fqlQuery} options={groupOptions} />
    </Box>
  )
}

export default observer(FqlGroupSelection)
